import React from 'react';
import { withRouter } from 'react-router-dom';

import Hidden from '@material-ui/core/Hidden';

import Menu from '../Menu';
import List from './List';
import Error from '../../../dialogs/Error';

class Catalogs extends React.Component {
    state = {
        hide: false,
        open: undefined,
    };

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    handleBack = () => {
        /*
            let path = this.props.history.location.pathname.split('/');
            path.splice(path.length - 1, 1);
            path = path.join('/');
            this.props.history.push(path);
            */
           if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    };

    render() {
        const { info } = this.props;
        if (
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '62' || f === '59' || f === '20')  &&
              info.security.licencias.some((f) => f.id === 154 && f.activo))
        ) {
            return <Error open id={'unauthorized_access'} handleClose={this.handleBack} />;
        } else {
            return (
                <div className={'flex_full_row bg_ice_blue'}>
                    <Hidden xsDown>
                        <div
                            className={
                                'flex_20 overflow_y_scroll padding_top_12 shadow_right_on_tablet bg_white'
                            }
                            onScroll={this.handleScroll}
                        >
                            <Menu code={3} />
                        </div>
                    </Hidden>
                    <div className={'flex_full_row center'}>
                        <div
                            className={
                                'flex_full overflow_y_scroll center height100 bg_ice_blue showbar'
                            }
                        >
                            <List />
                        </div>
                    </div>
                </div>
            );
        }
    }
}

export default withRouter(Catalogs);



// WEBPACK FOOTER //
// ./src/components/complex/inventory/catalogs/Index.js